export function addAriaLabelsToLinks() {
    const newTabLinks = document.querySelectorAll('a[target="_blank"]');

    if(newTabLinks.length === 0) return;

    newTabLinks.forEach(link => {
        const srElement = link.querySelector('.screen-reader-text');

        // if there is already a span
        if(srElement) {
            // and if it's text isn't 'opens in new tab'
            if (!srElement.textContent.includes('Opens in a new tab')) {
                srElement.textContent += ' - Opens in a new tab';
            }
        } else {
            // create a new span
            const srElement = document.createElement('span');
            srElement.classList.add('screen-reader-text');
            srElement.textContent = 'Opens in a new tab';
            link.appendChild(srElement);
        }
    })
}


// WEBPACK FOOTER //
// ./scripts/modules/aria-links.js